import styled from 'styled-components';
import { blurBox, timeDescription } from 'styles/parcelSharedStyles';
import HelperText from '../HelperText';

export const Container = styled.div<{ shouldRemoveSectionGap: boolean }>`
  margin-top: ${({ shouldRemoveSectionGap }) =>
    shouldRemoveSectionGap ? '0px' : '8px'};
`;

export const MainBox = styled.div`
  ${blurBox};
`;

export const RatingTitle = styled.div`
  ${timeDescription};
  font-weight: 700;
`;

export const RatingWrapper = styled.div`
  max-width: 250px;
`;

export const ErrorMessage = styled(HelperText).attrs({
  isError: true,
})`
  margin-top: 8px;
`;
